var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5"},[(_vm.containsData)?_c('div',{staticClass:"text-center"},[_vm._v("Select an itinerary to view more details")]):_c('div',{staticClass:"text-center"},[_vm._v("No itinerary data available")])])
}
var staticRenderFns = []

export { render, staticRenderFns }